interface iServiceInfo {
  park: boolean; // 일반주차여부
  robotPark: boolean; // 기계식주차여부
  wifi: boolean; // 무선와이파이여부
  genderSeparateToilet: boolean; // 남녀화장실구분여부
}

interface iAccountInfo {
  owner: string; // 계좌 소유자
  bank: string; // 은행명
  accountNo: string; // 계좌번호
}

interface iBusinessInfo {
  name: string; // 상호명
  owner: string; // 사업대표자명
  businessNo: string; // 사업자번호
  email: string; // 대표자이메일
}

interface iBranchInfoDetail {
  path: string; // router path
  name: string; // 지점 이름
  event: boolean;
  alias: string;
  lat: number; // 위도
  lng: number; // 경도
  address: string; // 주소
  oldAddress?: string; // 지번주소
  map: string; // 지도 링크
  tel: string; // 전화번호
  phone: string; // 휴대전화 번호
  time: string; // 운영시간
  service?: iServiceInfo; // 서비스 정보
  account?: iAccountInfo; // 계좌 정보
  business?: iBusinessInfo; // 사업자 정보
  blog?: string; // 블로그 주소
  inactive?: boolean; // 비활성화
}

type iBranchInfo = Record<string, iBranchInfoDetail>;

const information: iBranchInfo = {
  onedang: {
    path: "onedang",
    alias: "인천 원당점",
    name: "인천 원당 1호점",
    event: true,
    lat: 37.594593, //위도
    lng: 126.6975021, //경도
    address:
      "인천 서구 고산후로121번길 15 삼경프라자 4층 401호",
    oldAddress: "인천 서구 원당동 825-7 삼경프라자 4층 401호",
    map: "https://naver.me/59i2c8xt",
    tel: "032)715-7555",
    phone: "010-4239-8279",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사고우",
      bank: "농협은행",
      accountNo: "301-0334-7708-91"
    },
    business: {
      name: "주식회사고우",//상호명
      owner: "강윤권", //사업대표자명
      businessNo: "560-81-03060", //사업자번호
      email: "onitspace@naver.com" //대표자이메일
    },
    blog: "https://blog.naver.com/gowonit"
  },
  pyeongtaek: {
    path: "pyeongtaek",
    alias: "경기 평택점",
    event: true,
    name: "경기 평택 2호점",
    lat: 37.594593, //위도
    lng: 126.6975021, //경도
    address:
      "경기 평택시 중앙로 199 새샘빌딩 4층",
    oldAddress: "경기 평택시 비전동 764-1 새샘빌딩 4층",
    map: "https://naver.me/5smK3z6a",
    tel: "031)373-6128",
    phone: "010-4239-8279",
    time: "07:00 - 02:00 (연중무휴)",
    service: {
      park: false, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사고우",
      bank: "농협은행",
      accountNo: "301-0344-3855-71"
    },
    business: {
      name: "주식회사고우",//상호명
      owner: "강윤권", //사업대표자명
      businessNo: "560-81-03060", //사업자번호
      email: "onitspace@naver.com" //대표자이메일
    },
    blog: "https://blog.naver.com/gowonit"
  },
  yeongdeungpo: {
    path: "yeongdeungpo",
    alias: "서울 영등포구청점",
    name: "서울 영등포구청 3호점",
    event: true,
    lat: 37.594593, //위도
    lng: 126.6975021, //경도
    address:
      "서울 영등포구 영등포로19길 15 3층",
    oldAddress: "서울 영등포구 당산동2가 122 3층",
    map: "https://naver.me/GhbEeqHC",
    tel: "02-2633-7004",
    phone: "",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: false, //남녀화장실구분여부
    },
    account: {
      owner: "",
      bank: "",
      accountNo: ""
    },
    business: {
      name: "주식회사 리츠비",//상호명
      owner: "김수인", //사업대표자명
      businessNo: "557-81-02901", //사업자번호
      email: "" //대표자이메일
    },
    blog: "https://www.instagram.com/onit_share_office/",
    inactive: true
  },
  wonju: {
    path: "wonju",
    alias: "강원 원주점",
    event: false,
    name: "강원 원주 4호점",
    lat: 37.594593, //위도
    lng: 126.6975021, //경도
    address:
      "강원특별자치도 원주시 치악로 1555, 201호",
    oldAddress: "강원특별자치도 원주시 관설동 1461-1, 201호",
    map: "https://naver.me/xucEaRBU",
    tel: "",
    phone: "010-4239-8279",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: false, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 고우",
      bank: "농협은행",
      accountNo: "301-0355-8102-11"
    },
    business: {
      name: "주식회사고우",//상호명
      owner: "강윤권", //사업대표자명
      businessNo: "560-81-03060", //사업자번호
      email: "onitspace@naver.com" //대표자이메일
    },
    blog: "https://blog.naver.com/gowonit"
  },
  daegu: {
    path: "daegu",
    alias: "대구 칠곡점",
    event: true,
    name: "대구 칠곡 5호점",
    lat: 35.948077316856, //위도
    lng: 128.56727546143, //경도
    address:
      "대구 북구 학정동로 47 2층 서측",
    oldAddress: "대구 북구 학정동 976 2층 서측",
    map: "https://naver.me/5OQv7y7D",
    tel: "",
    phone: "0507-1478-5053",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 리리컴퍼니",
      bank: "국민은행",
      accountNo: "083701-04-095392"
    },
    business: {
      name: "주식회사 리리컴퍼니",//상호명
      owner: "김정자", //사업대표자명
      businessNo: "303-81-81707", //사업자번호
      email: "" //대표자이메일
    }
  },
  bugae: {
    path: "bugae",
    alias: "인천 부개점",
    event: true,
    name: "인천 부개 6호점",
    lat: 37.5047913, //위도
    lng: 126.7370765, //경도
    address:
      "인천 부평구 충선로 176-10 민우빌딩 4층,5층",
    oldAddress: "인천 부평구 부개동 12-152 민우빌딩 4층,5층",
    map: "https://naver.me/F9NS9ars",
    tel: "032-278-0909",
    phone: "",
    time: "06:00 - 02:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 솔온컴퍼니",
      bank: "국민은행",
      accountNo: "086601-04-167803"
    },
    business: {
      name: "주식회사 솔온컴퍼니",//상호명
      owner: "이규범", //사업대표자명
      businessNo: "403-86-03457", //사업자번호
      email: "" //대표자이메일
    },
  },
  yongam: {
    path: "yongam",
    alias: "청주 용암점",
    event: true,
    name: "청주 용암 7호점",
    lat: 36.6142818, //위도
    lng: 127.5037958, //경도
    address:
      "충청북도 청주시 상당구 용암북로 6번길 51, 2층",
    oldAddress: "충청북도 청주시 용암동 건영아파트 근처, 무인카페 2층",
    map: "https://naver.me/xf5ALdOx",
    tel: "043-715-3177",
    phone: "",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "온잇 공유오피스 청주용암점",
      bank: "기업은행",
      accountNo: "940-057349-04-010"
    },
    business: {
      name: "온잇 공유오피스 청주용암점",//상호명
      owner: "이승용", //사업대표자명
      businessNo: "253-85-03011", //사업자번호
      email: "" //대표자이메일
    },
    blog: "https://blog.naver.com/onit_cj"
  },
  anyang: {
    path: "anyang",
    alias: "경기 안양역점",
    event: false,
    name: "경기 안양역 8호점",
    lat: 37.39817512055, //위도
    lng: 126.92341595438, //경도
    address:
      "경기 안양시 만안구 장내로143번길 15 연성빌딩 6층",
    oldAddress: "경기 안양시 만인구 안양동 674-261 6층",
    map: "https://naver.me/F741UYH3",
    tel: "0507-1373-8321",
    phone: "",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: false, // 일반주차여부
      robotPark: true, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 유이어",
      bank: "국민은행",
      accountNo: "08370104095235"
    },
    business: {
      name: "주식회사 유이어",//상호명
      owner: "김영주", //사업대표자명
      businessNo: "897-86-03123", //사업자번호
      email: "" //대표자이메일
    },
    blog: "https://blog.naver.com/onit_anyang"
  },
  jeongwang: {
    path: "jeongwang",
    alias: "시흥 정왕점",
    event: true,
    name: "시흥 정왕 9호점",
    lat: 37.3531833, //위도
    lng: 126.7216064, //경도
    address:
      "경기 시흥시 옥구상가1길 23 청한빌딩 4층",
    oldAddress: "경기 시흥시 정왕동 1853-1 청한빌딩 4층",
    map: "https://naver.me/x67Yv8cJ",
    tel: "031-365-5865",
    phone: "",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 루마인다",
      bank: "신한은행",
      accountNo: "140-015-013207"
    },
    business: {
      name: "주식회사 루마인다",//상호명
      owner: "김정대", //사업대표자명
      businessNo: "206-87-09575", //사업자번호
      email: "" //대표자이메일
    },
    blog: "https://www.instagram.com/onit_sh"
  },
  // daegu - yongsan
  yongsan: {
    path: "yongsan",
    alias: "대구 용산점",
    event: true,
    name: "대구 용산 10호점",
    lat: 35.948077316856, //위도
    lng: 128.56727546143, //경도
    address:
      "대구 달서구 용산서로 14-8 3층",
    oldAddress: "용산청구타운 상가동 앞, 1층에 더벤티가 있는 건물 3층",
    map: "https://naver.me/5chM8jEv",
    tel: "",
    phone: "053-721-7427",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 서목",
      bank: "농협은행",
      accountNo: "301-0342-4373-31"
    },
    business: {
      name: "주식회사 서목",//상호명
      owner: "황샘결", //사업대표자명
      businessNo: "312-87-03217", //사업자번호
      email: "" //대표자이메일
    },
  },
  gyeyang: {
    path: "gyeyang",
    alias: "인천 계양구청점",
    event: true,
    name: "인천 계양구청 11호점",
    lat: 0, //위도
    lng: 0, //경도
    address:
      "인천광역시 계양구 계양문화로59번길 14 유정프라자 402호",
    oldAddress: "지번: 인천 계양구 계산동 1074-2",
    map: "https://naver.me/GbA2ecn9",
    tel: "032-548-2205",
    phone: "0507-1392-9263",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: false, //남녀화장실구분여부
    },
    blog: "https://blog.naver.com/monsjune",
    account: {
      owner: "주식회사 건빛",
      bank: "농협은행",
      accountNo: "301-0345-9086-61"
    },
    business: {
      name: "주식회사 건빛",//상호명
      owner: "임유진", //사업대표자명
      businessNo: "349-81-02974", //사업자번호
      email: "monsjune@naver.com" //대표자이메일
    },
  },
  bokdae: {
    path: "bokdae",
    alias: "청주 복대점",
    event: true,
    name: "청주 복대 12호점",
    lat: 36.634828251206, //위도
    lng: 127.42936505135, //경도
    address:
      "충청북도 청주시 흥덕구 진재로 41, 3층",
    oldAddress: "충청북도 청주시 흥덕구 복대동 2647번지, 3층",
    map: "https://naver.me/FUhTrs7r",
    tel: "043-233-4856",
    phone: "010-5585-4856",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: false, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 초신성",
      bank: "신한은행",
      accountNo: "140-014-975670"
    },
    business: {
      name: "주식회사 초신성",//상호명
      owner: "남현정", //사업대표자명
      businessNo: "454-81-03580", //사업자번호
      email: "onit_bokdae@naver.com" //대표자이메일
    },
    blog: "https://blog.naver.com/onit_bokdae"
  },
  apgujeong: {
    path: "apgujeong",
    alias: "서울 압구정점",
    event: true,
    name: "서울 압구정 13호점",
    lat: 37.525211292751, //위도
    lng: 127.02739899212, //경도
    address:
      "서울 강남구 압구정로 28길 22-6, 2층",
    oldAddress: "서울 강남구 신사동 577-8, 2층",
    map: "https://naver.me/xyTEU0Vo",
    tel: "02)6956-0500",
    phone: "010-5957-0555",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: false, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "유채호",
      bank: "IBK기업은행",
      accountNo: "469-012863-02-016"
    },
    business: {
      name: "온잇 압구정점",//상호명
      owner: "유채호", //사업대표자명
      businessNo: "605-46-99456", //사업자번호
      email: "" //대표자이메일
    },
    blog: "https://blog.naver.com/onitapgujeong"
  },
  amsa: {
    path: "amsa",
    alias: "서울 암사점",
    event: true,
    name: "서울 암사 14호점",
    lat: 37.525211292751, //위도
    lng: 127.02739899212, //경도
    address:
      "서울 강동구 올림픽로820, 4층 401호(암사동,서연빌딩)",
    oldAddress: "서울 강동구 암사동 462-3 4층",
    map: "https://naver.me/FoEdZ1VA",
    tel: "02)442-0156",
    phone: "010-6427-0156",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: false, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 더리처",
      bank: "농협은행",
      accountNo: "301-0346-7994-71"
    },
    business: {
      name: "주식회사 더리처",//상호명
      owner: "이서진", //사업대표자명
      businessNo: "899-86-03186 ", //사업자번호
      email: "ri2sarang@naver.com" //대표자이메일
    },
    blog: ""
  },
  baegot: {
    path: "baegot",
    alias: "시흥 배곧",
    event: false,
    name: "시흥 배곧 15호점",
    lat: 0, //위도
    lng: 0, //경도
    address:
      "경기 시흥시 서울대학로278번길 19-8, 8층 (써밋 C1 맞은편)",
    oldAddress: "경기 시흥시 배곧동 193-2 새롬프라자, 8층",
    map: "https://naver.me/5neWan4T",
    tel: "0507-1377-3469",
    phone: "",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 웰스자산 최재호",
      bank: "신한은행",
      accountNo: "140-014-799013"
    },
    business: {
      name: "공유오피스 온잇 배곧점",//상호명
      owner: "최재호", //사업대표자명
      businessNo: "880-88-03186", //사업자번호
      email: "wealthasset@naver.com" //대표자이메일
    },
    blog: "https://blog.naver.com/baegot_office"
  },
  hakik: {
    path: "hakik",
    alias: "인천 학익점",
    event: true,
    name: "인천 학익 16호점",
    lat: 37.5047913, //위도
    lng: 126.7370765, //경도
    address:
      "인천 미추홀구 소성로 97, 2층",
    oldAddress: "인천 미추홀구 학익동 420-6, 2층",
    map: "https://naver.me/GlJw7q5u",
    tel: "032-873-4098",
    phone: "",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 솔온컴퍼니",
      bank: "국민은행",
      accountNo: "086601-04-172140"
    },
    business: {
      name: "주식회사 솔온컴퍼니",//상호명
      owner: "이규범", //사업대표자명
      businessNo: "403-86-03457", //사업자번호
      email: "" //대표자이메일
    },
  },
  seouluni: {
    path: "seouluni",
    alias: "서울대점",
    event: false,
    name: "서울 서울대점 17호점",
    lat: 0, //위도
    lng: 0, //경도
    address:
      "서울 관악구 봉천로 445, 4층",
    oldAddress: "서울 관악구 봉천로 873-40, 4층",
    map: "https://naver.me/55r9LHMV",
    tel: "02-883-8632",
    phone: "",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: true, //남녀화장실구분여부
    },
    account: {
      owner: "주식회사 수지",
      bank: "하나은행",
      accountNo: "228-910021-01404",
    },
    business: {
      name: "주식회사 수지",//상호명
      owner: "김지애", //사업대표자명
      businessNo: "552-88-02962", // 사업자번호 
      email: "wwwabc0707@naver.com" //대표자이메일
    },
    blog: "https://blog.naver.com/wwwabc0707"
  },
  byeoryang: {
    path: "byeoryang",
    alias: "별양점",
    event: false,
    name: "과천 별양점 20호점",
    lat: 0, //위도
    lng: 0, //경도
    address:
      "경기도 과천시 별양상가1로 37, 501호",
    oldAddress: "경기 과천시 별양동 1-5 5층 501호",
    map: "https://naver.me/G9pAzhow",
    tel: "02-504-1220",
    phone: "010-3389-5860",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: false, //남녀화장실구분여부
    },
    account: {
      owner: "검은숲컴퍼니",
      bank: "신한은행",
      accountNo: "140-014-935787",
    },
    business: {
      name: "검은숲컴퍼니",//상호명
      owner: "임영진", //사업대표자명
      businessNo: "842-81-03680", // 사업자번호 
      email: "dam_party@naver.com" //대표자이메일
    },
    blog: ""
  },
  jakjeon: {
    path: "jakjeon",
    alias: "인천 작전점",
    event: true,
    name: "인천 작전 21호점",
    lat: 0, //위도
    lng: 0, //경도
    address:
      "인천광역시 계양구 장제로 719-17 4층 401호",
    oldAddress: "지번: 인천 계양구 작전동 897-2 4층",
    map: "https://naver.me/5T4op69y",
    tel: "032-548-2205",
    phone: "0507-1392-9263",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: false, //남녀화장실구분여부
    },
    blog: "https://blog.naver.com/monsjune",
    account: {
      owner: "주식회사 건빛",
      bank: "농협은행",
      accountNo: "301-0345-9086-61"
    },
    business: {
      name: "주식회사 건빛",//상호명
      owner: "임유진", //사업대표자명
      businessNo: "349-81-02974", //사업자번호
      email: "monsjune@naver.com" //대표자이메일
    },
  },
  bangi: {
    path: "bangi",
    alias: "서울 방이점",
    event: true,
    name: "서울 방이 24호점",
    lat: 0, //위도
    lng: 0, //경도
    address:
      "서울특별시 송파구 마천로 8길 1, 3층",
    oldAddress: "지번: 서울 송파구 오금동 42-2, 3층",
    map: "https://naver.me/Gdl6syS4",
    tel: "0507-1363-5282",
    phone: "",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: false, //남녀화장실구분여부
    },
    blog: "https://blog.naver.com/onit_bangi",
    account: {
      owner: "주식회사 복순",
      bank: "농협은행",
      accountNo: "301-0366-2747-51"
    },
    business: {
      name: "주식회사 복순",//상호명
      owner: "공진식", //사업대표자명
      businessNo: "186-87-03447", //사업자번호
      email: "creativill@naver.com" //대표자이메일
    },
  },
  yullyang: {
    path: "yullyang",
    alias: "청주 율량점",
    event: true,
    name: "청주시 율량 26호점",
    lat: 0, //위도
    lng: 0, //경도
    address:
      "충북 청주시 청원구 율봉로 183, 301호",
    oldAddress: "지번: 충북 청주시 청원구 율량동881",
    map: "https://naver.me/GtJn7gUw",
    tel: "010-6492-3579",
    phone: "0507-1315-3581",
    time: "00:00 - 24:00(연중무휴)",
    service: {
      park: true, // 일반주차여부
      robotPark: false, //기계식주차여부
      wifi: true,  //무선와이파이여부
      genderSeparateToilet: false, //남녀화장실구분여부
    },
    blog: "https://m.blog.naver.com/2024smiler",
    account: {
      owner: "주식회사 스마일리츠",
      bank: "신한은행",
      accountNo: "140-015-414666"
    },
    business: {
      name: "주식회사 스마일리츠",//상호명
      owner: "강세은", //사업대표자명
      businessNo: "203-81-68398", //사업자번호
      email: "2024smiler@naver.com" //대표자이메일
    },
  },
}

export default information;
export type { iBranchInfo, iBranchInfoDetail };